import { Menu } from "@headlessui/react";
import Icon from "hardcover-ui/components/Icon";
import { Link } from "@inertiajs/react";

import arrowAZ from "icons/regular/arrow-down-a-z.svg";
import arrowZA from "icons/regular/arrow-down-z-a.svg";
import arrow19 from "icons/regular/arrow-down-1-9.svg";
import arrow91 from "icons/regular/arrow-down-9-1.svg";
import arrowSymbolUp from "icons/regular/arrow-down-triangle-square.svg";
import arrowSymbolDown from "icons/regular/arrow-down-square-triangle.svg";
import checkIcon from "icons/solid/check.svg";
import classNames from "lib/classNames";
import { BookEditionOrderOption } from "./BookEditionSortButton";
import { GenerateEditionUrlParams } from "./BookEditionControls";

const sortLookup = {
  string: arrowAZ,
  string_desc: arrowZA,
  number: arrow19,
  number_desc: arrow91,
  symbol: arrowSymbolUp,
  symbol_desc: arrowSymbolDown,
};
export function findIcon(sortType: string, reverse = false) {
  return sortLookup[`${sortType}${reverse ? "_desc" : ""}`];
}

function oppositeDirection(direction: string) {
  return direction === "asc" ? "desc" : "asc";
}

export default function BookEditionSortListButton({
  active,
  orderOption,
  sortBy,
  sortDirection,
  generateUrl,
}: {
  active: boolean;
  orderOption: BookEditionOrderOption;
  sortBy: string;
  sortDirection: string;
  generateUrl: ({sortBy, sortDirection}: GenerateEditionUrlParams) => string;
}) {
  return (
    <Menu.Item as="div">
      <Link
        className="group font-semibold px-2 py-1 w-full flex flex-row items-center justify-between hover:bg-indigo-50 dark:hover:bg-gray-800"
        href={generateUrl({sortBy: orderOption.fieldname, sortDirection: active ? oppositeDirection(sortBy) : orderOption.defaultSortDirection})}
      >
        <div className="flex flex-row items-center">
          <Icon
            size="lg"
            icon={checkIcon}
            className={classNames(
              active ? "inline fill-green-500" : "invisible",
              "mr-2"
            )}
          />
          {orderOption.title}
        </div>
        {active ? (
          <div>
            <Icon
              size="lg"
              icon={findIcon(
                orderOption.type,
                sortDirection === "desc"
              )}
            />
            <div className="hidden group-hover:inline">
              {" "}
              →{" "}
              <Icon
                size="lg"
                icon={findIcon(
                  orderOption.type,
                  sortDirection !== "desc"
                )}
              />
            </div>
          </div>
        ) : (
          <Icon
            size="lg"
            icon={findIcon(orderOption.type, orderOption.defaultSortDirection === "desc")}
            className="hidden group-hover:inline"
          />
        )}
      </Link>
    </Menu.Item>
  );
}
